<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <!-- Group Name -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Group Name</mat-label>
        <input matInput [(ngModel)]="group().name" #nameInput/>
    </mat-form-field>

    <!-- Group Key -->
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Group Key</mat-label>
        <input matInput [(ngModel)]="group().key" appSlugInput [sourceInput]="nameInput" />
    </mat-form-field>

    <!-- @if (isAdmin) {
    <mat-form-field appearance="fill" class="full-width">
        <mat-label>Group HR Dept Code</mat-label>
        <input matInput [(ngModel)]="group().hrDeptCode" type="number" />
    </mat-form-field>
    } -->

    <!-- <div class="user-selector">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Owner</mat-label>
          <input matInput [formControl]="ownerControl" [matAutocomplete]="auto" />
          <mat-autocomplete #auto autoActiveFirstOption [displayWith]="displayOwnerWith"
            (optionSelected)="selectUser($event)">
            <mat-option *ngFor="let user of options | async" [value]="user">
              {{ user.displayName }} ({{ user.hawkId }})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div class="selected-user">
          <span>{{ selectedUser?.displayName ?? '[None selected]' }}</span>
          <button mat-icon-button *ngIf="selectedUser" (click)="selectedUser = undefined">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>     -->
    <!-- User List -->
    <!-- <table mat-table [dataSource]="userDataSource" class="mat-elevation-z8 full-width" color="primary">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Member</th>
            <td mat-cell *matCellDef="let user">{{ user.name }} ({{ user.hawkId}})</td>
        </ng-container>

        <ng-container matColumnDef="association">
            <th mat-header-cell *matHeaderCellDef>Association</th>
            <td mat-cell *matCellDef="let user">
                {{ user.groupMember?.isApprover }}
            </td>
        </ng-container>

        <ng-container matColumnDef="tools">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let user">
                <button mat-icon-button color="secondary"><mat-icon>remove</mat-icon></button>
            </td>
        </ng-container>

        <ng-container matColumnDef="footer-tools">
            <td mat-footer-cell *matFooterCellDef colspan="3" class="footer-tools">
                <div>
                    <mat-form-field appearance="fill">
                        <mat-label>User</mat-label>
                        <input matInput [formControl]="memberFilter" [matAutocomplete]="auto" (input)="filterUsers()"
                            (focus)="filterUsers()" #userFilterInput />
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="formatUserFn" requireSelection>
                        @for (option of options | async; track option) {
                        <mat-option [value]="option">{{option.displayName}} ({{option.hawkId}})</mat-option>
                        }
                    </mat-autocomplete>
                    <mat-form-field appearance="fill">
                        <mat-label>Role</mat-label>
                        <mat-select appearance="outline">
                            <mat-option>Testing</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-raised-button [disabled]="! memberFilter.value"><mat-icon>add</mat-icon> Add
                        member</button>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="no-results">
            <td mat-footer-cell *matFooterCellDef colspan="3">No members yet. You may add them below.</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="['footer-tools']"></tr>
        <tr [hidden]='userDataSource.data.length > 0' mat-footer-row *matFooterRowDef="['no-results']; sticky: true"
            class="no-results"></tr>
        <colgroup>
            <col />
            <col />
            <col width="1.5em" />
        </colgroup>
    </table>
    <div class="footer-tools">
        <div>
            <mat-form-field appearance="fill">
                <mat-label>User</mat-label>
                <input matInput [formControl]="memberFilter" [matAutocomplete]="auto" (input)="filterUsers()"
                    (focus)="filterUsers()" #userFilterInput />
            </mat-form-field>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="formatUserFn" requireSelection>
                @for (option of options | async; track option) {
                <mat-option [value]="option">{{option.displayName}} ({{option.hawkId}})</mat-option>
                }
            </mat-autocomplete>
            <mat-form-field appearance="fill">
                <mat-label>Role</mat-label>
                <mat-select appearance="outline">
                    <mat-option>Testing</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-raised-button [disabled]="! memberFilter.value"><mat-icon>add</mat-icon> Add member</button>
        </div>
    </div> -->
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="saveGroup()">Save</button>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-button (click)="cancel()">Cancel</button>
    <!-- <button mat-button (click)="cancel()" *ngIf="!data?.isNew">Done</button> -->
    <!-- <button mat-button color="primary" (click)="saveGroup()" *ngIf="data?.isNew">Create</button> -->
</mat-dialog-actions>